// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.intl-tel-input {
  width: 100%;
  position: relative; 
}

.intl-tel-input  .flag-container{
  padding-left: 1.3rem;;
}

.intl-tel-input input {
  height: 5.7rem;
  width: 100%;
  border-radius: 2.5rem;
  border: 0.4rem solid #EDEDED;
  font-size: 1.4rem;
}

.registration-form .intl-tel-input input {
  height: 4rem !important;
}

.intl-tel-input input:focus {
  border: 0.4rem solid #e58313;
}


.intl-tel-input .country-list,
.iti__country-list {
  z-index: 10000;                 
  background: #fff;            
  border: 0.4rem solid #EDEDED;
  border-top: 0;                
  border-bottom-left-radius: 2.5rem;
  border-bottom-right-radius: 2.5rem;
  box-shadow: none;             
}


.intl-tel-input .country-list:not(.hide),
.iti__country-list:not(.iti__hide) {
  border-color:#EDEDED;
}


.intl-tel-input .country-list .country.highlight {
  background: #f3f3f3;
}`, "",{"version":3,"sources":["webpack://./src/components/WePhoneInput/styles.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;;AAGA;;EAEE,cAAc;EACd,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,iCAAiC;EACjC,kCAAkC;EAClC,gBAAgB;AAClB;;;AAGA;;EAEE,oBAAoB;AACtB;;;AAGA;EACE,mBAAmB;AACrB","sourcesContent":[".intl-tel-input {\n  width: 100%;\n  position: relative; \n}\n\n.intl-tel-input  .flag-container{\n  padding-left: 1.3rem;;\n}\n\n.intl-tel-input input {\n  height: 5.7rem;\n  width: 100%;\n  border-radius: 2.5rem;\n  border: 0.4rem solid #EDEDED;\n  font-size: 1.4rem;\n}\n\n.registration-form .intl-tel-input input {\n  height: 4rem !important;\n}\n\n.intl-tel-input input:focus {\n  border: 0.4rem solid #e58313;\n}\n\n\n.intl-tel-input .country-list,\n.iti__country-list {\n  z-index: 10000;                 \n  background: #fff;            \n  border: 0.4rem solid #EDEDED;\n  border-top: 0;                \n  border-bottom-left-radius: 2.5rem;\n  border-bottom-right-radius: 2.5rem;\n  box-shadow: none;             \n}\n\n\n.intl-tel-input .country-list:not(.hide),\n.iti__country-list:not(.iti__hide) {\n  border-color:#EDEDED;\n}\n\n\n.intl-tel-input .country-list .country.highlight {\n  background: #f3f3f3;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
